// スクロール位置の自前管理（Shopify は no-store で bfcache 無効のため）
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

// ページを離れるとき: スクロール位置を sessionStorage に保存
window.addEventListener('pagehide', function() {
  sessionStorage.setItem('__pz_scroll_' + location.pathname, String(window.scrollY));
});

// bfcache から復元されたとき: scrollRestoration='manual' で scroll=0 になるため手動復元
window.addEventListener('pageshow', function(e) {
  if (!e.persisted) return;
  var pos = parseInt(sessionStorage.getItem('__pz_scroll_' + location.pathname) || '0', 10);
  if (pos > 0) window.scrollTo(0, pos);
});

window.addEventListener('DOMContentLoaded', () => {
  var navEntries = performance && performance.getEntriesByType && performance.getEntriesByType('navigation');
  var navType = navEntries && navEntries[0] && navEntries[0].type;
  var scrollKey = '__pz_scroll_' + location.pathname;
  var savedScroll = sessionStorage.getItem(scrollKey);

  // 外部からの fresh 訪問（Google等）: キー削除してアニメーション通常起動
  var isExternal = !document.referrer || document.referrer.indexOf(location.hostname) === -1;
  if (navType === 'navigate' && isExternal) {
    sessionStorage.removeItem(scrollKey);
    initializeScrollAnimationTrigger();
    initializeScrollZoomAnimationTrigger();
    console.log('[animations.js] fresh external visit, animations enabled');
    return;
  }

  // バック/リロード/サイト内遷移: アニメーションをスキップ
  // back_forward: bfcache (iOS Safari 通常ケース)
  // reload: Chrome/Android のバックナビゲーション
  // savedScroll あり: iOS Safari bfcache 失敗時の fallback
  var shouldSkip = (navType === 'back_forward') ||
                   (navType === 'reload') ||
                   (savedScroll !== null);

  console.log('[animations.js] navType:', navType, 'savedScroll:', savedScroll, 'skip:', shouldSkip);

  if (shouldSkip) {
    document.querySelectorAll('.scroll-trigger').forEach(function(el) {
      el.classList.remove('animate--fade-in');
      el.classList.remove('animate--slide-in');
      el.classList.remove('scroll-trigger--offscreen');
    });

    // スクロール位置を手動復元
    // history.scrollRestoration = 'manual' により browser は自動復元しないため自前で行う
    if (savedScroll !== null) {
      sessionStorage.removeItem(scrollKey);
      var pos = parseInt(savedScroll, 10);
      if (pos > 0) {
        // 即時復元（DOMContentLoaded時点でレイアウトが確定していなくてもまず試みる）
        window.scrollTo(0, pos);
        // 画像等のロード後に再度確定 + フェードイン（リロードフラッシュを隠す）
        window.addEventListener('load', function() {
          window.scrollTo(0, pos);
          // <head> インラインスクリプトで opacity:0 にしていた場合はここでフェードイン
          var htmlEl = document.documentElement;
          if (htmlEl.style.opacity === '0') {
            htmlEl.style.transition = 'opacity 0.15s ease';
            htmlEl.style.opacity = '1';
            setTimeout(function() { htmlEl.style.transition = ''; }, 250);
          }
        }, { once: true });
      }
    }

    return;
  }

  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
